import { isPending } from "App/apiMiddleware";
import usersActionTypes from "Areas/Settings/users/redux/actionTypes";
import get from "lodash/get";
import { createSelector } from "reselect";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const buildReduxAccessLevelKey = (objectId, entity) => `${objectId}_${entity}`;
export const getAccessLevels = createSelector((state) => get(state, `[${NAMESPACE}].data`), (_, objectId) => objectId, (_, __, entity) => entity, (data, objectId, entity) => data ? data[buildReduxAccessLevelKey(objectId, entity)] : undefined);
export const getIsOpen = createSelector((state) => get(state, `[${NAMESPACE}].isOpen`), (isOpen) => isOpen);
export const getInProgress = (state, objectId, entity) => isPending(state, usersActionTypes.GET_USERS) ||
    isPending(state, `${actionTypes.GET_ACCESS_LEVELS}_${buildReduxAccessLevelKey(objectId, entity)}`);
